import * as React from "react";
import { useTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { FormCard } from "Components/Form/FormCard";
import { Descriptions, Button } from "antd";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { RouterStore } from "Config/CustomBrowserRouter";
import { AdminDBMigration } from "./AdminDBMigration";
import { ButtonsRow } from "Components/Form/ButtonsRow";
import { Link } from "react-router-dom";

export const AdminSysInfoReport = () => {
  const { t } = useTranslation(I18N_NS.ADMIN);
  const [loading, setLoading] = React.useState(false);
  const [data, setData] = React.useState<API_SystemCheckInfo>({});

  const goToDetails = () => RouterStore.push("/admin/system-info");
  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await API.getData<API_SystemCheckInfo>(API_URL.ADMIN.getSystemCheckInfo());
      setData(response);
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    fetchData();
  }, []);

  return (
    <FormCard loading={loading} title={t("System information")} className="mb-2">
      <div className="mb-2">
        <Link to="/admin/logs" className="link">
          {t("Admin Logs")}
        </Link>
      </div>
      <Descriptions layout="vertical" size="small" className="mb-2">
        <Descriptions.Item label={t("Running Nodes")}>{data.runningNodes}</Descriptions.Item>
        <Descriptions.Item label={t("Current Users")}>{data.currentUser}</Descriptions.Item>
        <Descriptions.Item label={t("Free Storage")}>{data.freeStorage}</Descriptions.Item>
      </Descriptions>
      <ButtonsRow justify="space-between">
        <AdminDBMigration />
        <Button type="primary" onClick={goToDetails}>
          {t("Details")}
        </Button>
      </ButtonsRow>
    </FormCard>
  );
};
